import { useTranslation } from 'react-i18next';

import { LANGUAGES, setLang, useLang } from '@/lib/lang';
import { cn } from '@/lib/utils';

/**
 * Interface-language toggle.
 *
 * Deliberately distinct from the "Spoken language" field on the Launch card, which
 * sets the accent the characters speak in the finished film.
 */
export default function LanguageSwitcher() {
  const lang = useLang();
  const { t } = useTranslation();

  return (
    <div role="group" aria-label={t('lang.label')} className="flex items-center overflow-hidden rounded-md border border-border">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          title={l.label}
          className={cn(
            'px-1.5 py-0.5 text-[10px] font-medium transition-colors',
            lang === l.code ? 'bg-primary text-primary-foreground' : 'text-faint hover:text-foreground',
          )}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}
